import React from 'react';
import { Shield, Info, ArrowRight, CheckCircle } from 'lucide-react';

export default function ConsentModal({ onAccept }) {
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-md animate-fade-in">
            <div className="bg-white rounded-[2.5rem] max-w-lg w-full p-8 md:p-10 shadow-2xl relative overflow-hidden animate-scale-up">

                {/* Decorative Background */}
                <div className="absolute top-0 right-0 w-40 h-40 bg-indigo-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-emerald-50 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

                <div className="relative z-10 text-center">
                    <div className="w-20 h-20 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center mb-6 mx-auto shadow-sm ring-4 ring-white">
                        <Shield className="w-10 h-10" />
                    </div>

                    <h3 className="text-2xl md:text-3xl font-black text-slate-900 mb-4 tracking-tight"> Transparency & Ethics</h3>
                    <p className="text-slate-500 font-bold text-xs uppercase tracking-widest mb-8">Eager Student Charter</p>

                    <div className="space-y-6 text-left mb-10">
                        <div className="flex gap-4 items-start">
                            <div className="mt-1 p-1 bg-emerald-50 rounded-md text-emerald-600">
                                <CheckCircle className="w-4 h-4" />
                            </div>
                            <p className="text-sm text-slate-600 leading-relaxed">
                                <strong className="text-slate-900">Bridging the Gap:</strong> Eager is designed to bridge the market gap between students and the actual market by showing all available courses and colleges, bringing them to your hands in the best possible way.
                            </p>
                        </div>

                        <div className="flex gap-4 items-start">
                            <div className="mt-1 p-1 bg-indigo-50 rounded-md text-indigo-600">
                                <Info className="w-4 h-4" />
                            </div>
                            <p className="text-sm text-slate-600 leading-relaxed">
                                <strong className="text-slate-900">Accountability:</strong> While we provide the compass and the toolkit, <strong className="text-rose-600 underline decoration-rose-200 decoration-2">Eager is not promising or guaranteeing your future</strong>. Your success depends on your effort, consistency, and the choices you make.
                            </p>
                        </div>
                    </div>

                    <button
                        onClick={onAccept}
                        className="w-full py-4 bg-slate-900 hover:bg-slate-800 text-white rounded-2xl font-black transition-all shadow-xl shadow-slate-900/20 active:scale-[0.98] flex items-center justify-center gap-3 group"
                    >
                        <span>I Acknowledge & Understand</span>
                        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    </button>

                    <p className="text-[10px] text-slate-400 mt-6 font-medium">
                        By continuing, you acknowledge that Eager is a decision-support platform and not a replacement for individual merit or destiny.
                    </p>
                </div>
            </div>
        </div>
    );
}
